<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="2">
          <v-select
            :items="years"
            v-model="year"
            label="Год"
            @update:modelValue="yearChange()"
            variant="underlined"
          ></v-select>
        </v-col>
        <v-col md="4">
          <v-select
            :items="groups"
            v-model="selectedGroup"
            item-title="name"
            item-value="id"
            label="Группа"
            variant="underlined"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>

    <v-card>
      <v-alert v-if="alert" dense type="warning">
        {{ alert }}
      </v-alert>

      <v-tabs v-model="tab" show-arrows="always">
        <v-tab v-for="hitem in hItems" :key="hitem.name">
          {{ hitem.name }}
        </v-tab>
      </v-tabs>

      <v-window v-model="tab">
        <v-window-item v-for="hitem in hItems" :key="hitem.name">
          <v-card flat>
            <v-card-text>
              <v-data-table
                :items="students[selectedGroup]"
                :headers="headers"
                items-per-page="-1"
                style="max-height:100vh"
              >
                <template v-slot:headers="{ columns }">
                  <tr>
                    <th>№</th>
                    <th>ФИО</th>

                    <template v-for="head in columns">
                      <th
                        :key="head.key"
                        v-if="head.class === hitem.class"
                        :class="head.class"
                      >
                        <v-tooltip location="top" :text="head.title" max-width="800">
                          <template v-slot:activator="{ props }">
                            <div v-bind="props" class="hide-long-text">
                              {{ head.title }}
                            </div>
                          </template>
                        </v-tooltip>
                      </th>
                    </template>
                  </tr>
                </template>

                <template v-slot:body="{ items, headers }">
                  <tr v-for="(item, idx) in items" :key="idx">
                    <td>{{ idx + 1 }}</td>
                    <td>
                      <span
                        :class="
                          isValid(item) > 0 ? '' : 'bg-orange-lighten-3'
                        "
                        >{{ item.lastname }}&nbsp;{{
                          item.firstname
                        }}&nbsp;{{ item.patronymic }}</span
                      >
                      <p>{{ item.lastmodified }}</p>
                    </td>

                    <template v-for="(header, key) in headers[0]">
                      <td
                        :key="key"
                        :class="header.class"
                        v-if="header.class === hitem.class"
                      >
                        <template v-if="header.value == 'name'">
                          <span
                            :class="
                              isValid(item) > 0 ? '' : 'bg-orange-lighten-3'
                            "
                            >{{ item.lastname }}&nbsp;{{
                              item.firstname
                            }}&nbsp;{{ item.patronymic }}</span
                          >
                          <p>{{ item.lastmodified }}</p>
                        </template>
                        <template v-else>
                          <v-checkbox
                            :disabled="!$model.isCurator && !$model.isAdmin"
                            v-model="
                              students[selectedGroup][idx][[header.value]]
                            "
                            color="success"
                            hide-details
                            value="1"
                            @change="editItem(selectedGroup, idx, header.value)"
                          ></v-checkbox>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>

                <template v-slot:bottom> </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "teacher",
  data() {
    return {
      tab: null,
      hItems: [
        {
          name: "общие",
          class: "base",
        },
        {
          name: "занятые выпускники",
          class: "platinum",
        },
        {
          name: "Потенциальная занятость",
          class: "lightblue",
        },
        {
          name: "Зона риска",
          class: "lightyellow",
        },
        {
          name: "Прочее, редкие жизненные обстоятельства",
          class: "lightgreen",
        },
        {
          name: "Профессиональные намерения выпускников",
          class: "margenta",
        },
        {
          name: "здоровье(из общей численности выпускников из числа лиц с ОВЗ, инвалидов и детей-инвалидов)",
          class: "health",
        },
      ],

      dialog1: false,
      dialog2: false,
      years: [],
      year: null,
      selectedGroup: null,
      groups: [],
      alert: "",
      students: {},
      sortByH: ["ovz", "ovz_invalid", "invalid", "target"],
      oneOf: [
        "business",
        "freelance",
        "student",
        "army",
        "army_contract",
        "parental_leave",
        "unformal_job",
        "looking_job",
        "marginal",
        "other_unemployed",
        "health_problems",
        "prisoner",
        "migrant",
        "family_problems",
        "no_snils",
        "other_unemployed1",
        "will_job",
        "will_business",
        "will_freelance",
        "will_army",
        "will_army_contract",
        "will_student",
      ],
      health: [
        "eye_trouble",
        "hearing_trouble",
        "moving_trouble",
        "speaking_trouble",
        "mental_trouble",
        "autism",
        "other_invalid",
        "ovz_invalid",
        "abilimpiks",
      ],
      headers: [
        {
          title: "ФИО",
          sortable: true,
          key: "name",
        },
        {
          title: "ОВЗ",
          sortable: true,
          key: "ovz",
          class: "base",
        },
        {
          title: "из числа лиц с ОВЗ: инвалиды и дети-инвалиды",
          sortable: true,
          key: "ovz_invalid",
          class: "base",
        },
        {
          title: "Инвалиды и дети-инвалиды (кроме учтенных в колонке 02)",
          sortable: true,
          key: "invalid",
          class: "base",
        },
        {
          title: "Имеют договор о целевом обучении",
          sortable: true,
          key: "target",
          class: "base",
        },
        {
          title: "с нарушениями: зрения",
          sortable: true,
          key: "eye_trouble",
          class: "health",
        },
        {
          title: "с нарушениями: слуха",
          sortable: true,
          key: "hearing_trouble",
          class: "health",
        },
        {
          title: "с нарушениями: опорно-двигательного аппарата",
          sortable: true,
          key: "moving_trouble",
          class: "health",
        },
        {
          title: "с нарушениями: тяжелыми нарушениями речи",
          sortable: true,
          key: "speaking_trouble",
          class: "health",
        },
        {
          title: "с нарушениями: задержкой психического развития",
          sortable: true,
          key: "mental_trouble",
          class: "health",
        },
        {
          title: "с нарушениями:  расстройствами аутистического спектра",
          sortable: true,
          key: "autism",
          class: "health",
        },
        {
          title: "с нарушениями:  с инвалидностью вследствие других причин",
          sortable: true,
          key: "other_invalid",
          class: "health",
        },
        {
          title: "имеют договор о целевом обучении",
          sortable: true,
          key: "ovz_target",
          class: "health",
        },
        {
          title: "принимали участие в чемпионате «Абилимпикс»",
          sortable: true,
          key: "abilimpiks",
          class: "health",
        },
        {
          title:
            "Трудоустроены (по трудовому договору, договору ГПХ в соответствии с трудовым законодательством, \
                    законодательством  об обязательном пенсионном страховании)",
          sortable: true,
          key: "has_job",
          class: "platinum",
        },
        {
          title:
            "В том числе (из трудоустроенных): в соответствии с освоенной профессией, специальностью \
                    (исходя из осуществляемой трудовой функции)",
          sortable: true,
          key: "has_job_by_spec",
          class: "platinum",
        },
        {
          title:
            "В том числе (из трудоустроенных): работают на протяжении не менее 4-х месяцев на последнем месте работы",
          sortable: true,
          key: "has_job_4month",
          class: "platinum",
        },
        {
          title: "Индивидуальные предприниматели",
          sortable: true,
          key: "business",
          class: "platinum",
        },
        {
          title:
            "Самозанятые (перешедшие на специальный налоговый режим  - налог на профессио-нальный доход)",
          sortable: true,
          key: "freelance",
          class: "platinum",
        },
        {
          title: "Продолжили обучение",
          sortable: true,
          key: "student",
          class: "platinum",
        },
        {
          title: "Проходят службу в армии по призыву",
          sortable: true,
          key: "army",
          class: "lightblue",
        },
        {
          title:
            "Проходят службу в армии на контрактной основе, в органах внутренних дел, Государственной противопожарной службе, \
                    органах по контролю за оборотом наркотических средств и психотропных веществ, учреждениях и органах уголовно-исполнительной системы, \
                    войсках национальной гвардии Российской Федерации, органах принудительного исполнения Российской Федерации",
          sortable: true,
          key: "army_contract",
          class: "lightblue",
        },
        {
          title: "Находятся в отпуске по уходу за ребенком",
          sortable: true,
          key: "parental_leave",
          class: "lightblue",
        },
        {
          title: "Неформальная занятость (нелегальная)",
          sortable: true,
          key: "unformal_job",
          class: "lightyellow",
        },
        {
          title:
            "Зарегистрированы в центрах занятости в качестве безработных (получают пособие по безработице) и не планируют трудоустраиваться",
          sortable: true,
          key: "looking_job",
          class: "lightyellow",
        },
        {
          title:
            "Не имеют мотивации к трудоустройству (кроме зарегистрированных в качестве безработных) и не планируют трудоустраиваться, \
                    в том числе по причинам получения иных социальных льгот",
          sortable: true,
          key: "marginal",
          class: "lightyellow",
        },
        {
          title: "Иные причины нахождения под риском нетрудоустройства",
          sortable: true,
          key: "other_unemployed",
          class: "lightyellow",
        },
        {
          title: "Смерть, тяжелое состояние здоровья",
          sortable: true,
          key: "health_problems",
          class: "lightgreen",
        },
        {
          title: "Находятся под следствием, отбывают наказание",
          sortable: true,
          key: "prisoner",
          class: "lightgreen",
        },
        {
          title:
            "Переезд за пределы Российской Федерации(кроме переезда в иные регионы - по ним регион должен располагать сведениями)",
          sortable: true,
          key: "migrant",
          class: "lightgreen",
        },
        {
          title:
            "Не могут трудоустраиваться в связи с уходом за больными родственниками, в связи с иными семейными обстоятельствами",
          sortable: true,
          key: "family_problems",
          class: "lightgreen",
        },
        {
          title:
            "Выпускники из числа иностранных граждан, которые не имеют СНИЛС",
          sortable: true,
          key: "no_snils",
          class: "lightgreen",
        },
        {
          title:
            "Иное(в первую очередь выпускники распределяются по всем остальным графам)",
          sortable: true,
          key: "other_unemployed1",
          class: "lightgreen",
        },
        {
          title: "будут трудоустроены",
          sortable: true,
          key: "will_job",
          class: "margenta",
        },
        {
          title: "будут осуществлять предпринимательскую деятельность",
          sortable: true,
          key: "will_business",
          class: "margenta",
        },
        {
          title: "будут самозанятыми",
          sortable: true,
          key: "will_freelance",
          class: "margenta",
        },
        {
          title: "будут призваны в армию",
          sortable: true,
          key: "will_army",
          class: "margenta",
        },
        {
          title:
            "будут в армии на контрактной основе, в органах внутренних дел, Государственной противопожарной службе, \
                    органах по контролю за оборотом наркотических средств и психотропных веществ, учреждениях и органах уголовно-исполнительной системы, \
                    войсках национальной гвардии Российской Федерации, органах принудительного исполнения Российской Федерации",
          sortable: true,
          key: "will_army_contract",
          class: "margenta",
        },
        {
          title: "будут продолжать обучение",
          sortable: true,
          key: "will_student",
          class: "margenta",
        },
      ],
    };
  },
  created() {
    for (let i = 0; i <= 2; i++) {
      this.years.push(new Date().getFullYear() - i);
    }
    this.year = this.years[0];
    this.getGroups();
  },
  methods: {
    isValid(student) {
      return 1;
      /*
      console.log(JSON.stringify(student))
      student = JSON.parse(JSON.stringify(student)); //from proxy to array
      let r = 0;
      this.oneOf.forEach((element) => {
        r += parseInt(student[element] ?? 0);
      });
      r +=
        parseInt(student["has_job"] ?? 0) +
        parseInt(student["has_job_4month"] ?? 0) +
        parseInt(student["has_job_by_spec"] ?? 0);
        */
      return r;
    },
    editItem(group, index, varname) {
      //нельзя галочками отметить вообще все строки
      this.alert = "";
      if (
        this.health.includes(varname) &&
        this.students[group][index]["ovz"] != 1 &&
        this.students[group][index]["invalid"] != 1
      ) {
        this.alert =
          "Не забудьте указать категорию 'ОВЗ' или 'Инвалид' на вкладке 'общие'";
      }
      if (
        varname == "ovz_invalid" &&
        this.students[group][index]["ovz_invalid"] == 1
      ) {
        this.students[group][index]["ovz"] = "1";
        this.students[group][index]["invalid"] = 0;
      }

      if (varname == "invalid" && this.students[group][index]["invalid"] == 1) {
        this.students[group][index]["ovz_invalid"] = 0;
        this.students[group][index]["ovz"] = 0;
      }

      if (varname == "ovz" && this.students[group][index]["ovz"] == 1) {
        this.students[group][index]["invalid"] = 0;
      }
      //------------------------------
      if (varname == "ovz" && this.students[group][index]["ovz"] == 1) {
        this.students[group][index]["invalid"] = 0;
      }

      if (varname == "ovz" && this.students[group][index]["ovz"] != 1) {
        this.students[group][index]["ovz_invalid"] = 0;
      }

      if (varname == "has_job_by_spec" || varname == "has_job_4month") {
        this.students[group][index]["has_job"] = "1";
      }

      if (varname == "has_job" && this.students[group][index]["has_job"] != 1) {
        this.students[group][index]["has_job_4month"] = 0;
        this.students[group][index]["has_job_by_spec"] = 0;
      }

      if (this.oneOf.includes(varname)) {
        this.students[group][index]["has_job"] = 0;
        this.students[group][index]["has_job_4month"] = 0;
        this.students[group][index]["has_job_by_spec"] = 0;
      }

      for (let prop in this.students[group][index]) {
        if (
          this.oneOf.includes(prop) &&
          prop != varname &&
          !this.sortByH.includes(varname)
        ) {
          this.students[group][index][prop] = 0;
        }
      }
      //------------------------------------
      let student = this.students[group][index];
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/setStudentData",
          new URLSearchParams({
            student: JSON.stringify(student),
            year: this.year,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.students[group][index]["id"] = resp.data;
        })
        .catch((reject) => {
          if (
            reject.response != undefined &&
            reject.response.data != undefined
          ) {
            this.$eventBus.$emit("show-dialog", "Ошибка", reject.response.data);
          }
        });
    },
    yearChange() {
      this.getGroups();
    },
    getGroups() {
      this.groups = [];
      this.students = {};

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/getGroups",
          new URLSearchParams({
            year: this.year,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          if (!Array.isArray(resp.data)) {
            this.$eventBus.$emit("show-dialog", "Ошибка", resp.data);
            return;
          }

          resp.data.forEach((group) => {
            //ебаный чекбокс, принимает value как строку
            group.students.forEach((student) => {
              for (let prop in student) {
                if (typeof student[prop] == "number") {
                  student[prop] = student[prop].toString();
                }
              }
            });

            this.groups.push(group.group);
            this.students[group.group.id] = group.students;
          });
        })
        .catch((reject) => {
          if (
            reject.response != undefined &&
            reject.response.data != undefined
          ) {
            this.$eventBus.$emit("show-dialog", "Ошибка", reject.response.data);
          }
        });
    },
  },
};
</script>
<style scoped>
.v-table__wrapper th {
  /*max-width: 250px;*/
}

table > tbody > tr > td:nth-child(2),
table > thead > tr > th:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 1;
  background-color: white;
}

table > thead > tr > th:nth-child(1) {
  z-index: 1;
}

.hide-long-text {
  max-height: 150px;
  overflow: hidden;
}

.platinum {
  background-color: #f0f0f0 !important;
}

.lightblue {
  background-color: #f0ffff !important;
}

.lightyellow {
  background-color: #fffff0 !important;
}

.lightgreen {
  background-color: #f0fff0 !important;
}

.margenta {
  background-color: #fff0ff !important;
}

.v-tab {
  max-width: 250px;
}

:deep(.v-btn__content) {
  white-space: normal;
}
</style>
